import '../register.scss';
import React from 'react';
import { Row, Col, Button, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import MessageModal from '../../../../shared/message/message-modal';
import { reset, handleRegister } from '../register.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { IND, ENP, ORG, SUCCESS, LINK_TERM_OF_USE, ERROR, APP_LOCAL_DATE_FORMAT, Rester_Type } from 'app/config/constants';
import ShowMessageModal from '../showMessage-modal';
import { login } from 'app/shared/util/utilities';
import moment from 'moment';
import RegisterBottom from '../registerBottom';
import ComponentDatePicker from 'app/shared/component/ComponentDatePicker';
import { generateCaptcha } from 'app/modules/account/password-reset/password-reset.reducer';
import PageNotFound from 'app/shared/error/page-not-found';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

export interface IRegisterInfoAccProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IRegisterInfoAccState {
  visible: boolean;
  color: string;
  message: string;
  redirectLogin: boolean;
  showMessage: boolean;
  userType: string;
  isMobile: boolean;
  disableButtonReg: boolean;
  captcha: string;
  errorMessage: string;
  name: string;
  email: string;
  birthday: Date;
  required: boolean;
}
export class RegisterCcvcInfo extends React.Component<IRegisterInfoAccProps, IRegisterInfoAccState> {
  state: IRegisterInfoAccState = {
    visible: false,
    color: 'danger',
    message: '',
    redirectLogin: false,
    showMessage: false,
    userType: '',
    isMobile: false,
    disableButtonReg: false,
    captcha: '',
    errorMessage: '',
    name: '',
    email: '',
    birthday: null,
    required: false
  };

  componentWillMount() {
    this.props.generateCaptcha();
    const userType = Storage.session.get('userType');
    window['is_mobile']();
    if (this.props.location.state) {
      this.setState({
        email: this.props.location.state.email,
        name: this.props.location.state.name
      });
    }
    this.setState({
      userType: userType,
      isMobile: window['isMobile']
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.resultReg !== nextProps.resultReg) {
      const { resultReg } = nextProps;

      if (resultReg && resultReg.status === SUCCESS) {
        this.setState({
          disableButtonReg: false,
          // showMessage: true
          redirectLogin: true
        });
        // let timerId = setTimeout(() => {
        //   this.setState({
        //     showMessage: false,
        //     redirectLogin: true
        //   });
        // }, 3000);
      } else if (resultReg && resultReg.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: resultReg.message && resultReg.message !== ERROR ? resultReg.message : translate('register.messages.error.fail')
        });
      } else {
        this.setState({
          disableButtonReg: false
        });
      }
    }
    if (nextProps.registrationFailure) {
      this.setState({
        disableButtonReg: false,
        visible: true,
        color: 'danger',
        message: 'Có lỗi xảy ra. Vui lòng thử lại sau!'
      });
    }
    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    } else {
      this.props.generateCaptcha();
    }
  }

  componentWillUnmount() {
    // this.props.reset();
  }

  handleChangeDate = date => {
    this.setState({
      birthday: date,
      required: false
    });
  };

  handleValidSubmit = (event, values) => {
    let { email, mobile, type } = this.props.location.state;
    values.fullName = values.fullName.trim();
    values.identity = values.identity.trim();
    values.mobile = values.mobile.trim();
    values.email = values.email.trim();
    values.type = IND;

    values.birthday = this.state.birthday ? moment(this.state.birthday).format(APP_LOCAL_DATE_FORMAT) : '';
    if (values.identity.length === 8 && isNaN(values.identity.charAt(0) * 1)) {
      values.passport = values.identity.toUpperCase();
      values.identity = '';
    }

    if (!values.birthday) {
      this.setState({
        required: true
      });
      window['autoFocus']('birthday');
    } else {
      this.setState({
        required: false
      });
      this.props.handleRegister(values);
      this.setState({ disableButtonReg: true });
    }
    event.preventDefault();
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  render() {
    if (this.state.redirectLogin) {
      // login(this.props.config);
      return (
        <Redirect
          push
          to={{
            pathname: `/success`,
            state: {
              config: this.props.config
            }
          }}
        />
      );
    }

    if (!this.props.location.state) {
      return <ErrorBoundaryRoute component={PageNotFound} />;
    }

    let { email, mobile, type } = this.props.location.state;

    return (
      <div className="box-register1" style={{ marginBottom: '60px' }}>
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã đăng ký thành công'} />
        <Row className="justify-content-center">
          <Col md="12">
            <h2 className="text-center font-weight-bold" id="register-title">
              <Translate contentKey="register.titleInfo">Registration</Translate>
            </h2>
            <p className="text-center txtContent">
              <Translate contentKey="register.txtContent" />
            </p>
            <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="12">
            <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
              <AvField
                name="identity"
                label={translate('global.form.cmt.label')}
                placeholder={translate('global.form.cmt.placeholder')}
                // autoFocus={!this.state.isMobile}
                type="number"
                validate={{
                  required: { value: true, errorMessage: translate('register.messages.validate.cmt/cccd.required') },
                  pattern: {
                    value: '^([0-9]{9}|[0-9]{12})+$',
                    errorMessage: translate('register.messages.validate.cmt/cccd.minlength')
                  },
                  minLength: { value: 9, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') },
                  maxLength: { value: 12, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') }
                }}
              />

              <AvField
                name="fullName"
                label={translate('global.form.fullname.label')}
                placeholder={translate('global.form.fullname.placeholder')}
                validate={{
                  required: { value: true, errorMessage: translate('register.messages.validate.fullname.required') },
                  maxLength: { value: 250, errorMessage: 'Họ tên quá dài' }
                }}
              />

              <ComponentDatePicker
                name="birthday"
                value={this.state.birthday}
                required={this.state.required}
                handleChange={this.handleChangeDate}
                label={translate('global.form.birthday.label')}
                placeHolder="dd/mm/yyyy"
              />

              <AvField
                name="email"
                label={translate('global.form.email.require')}
                placeholder={translate('global.form.email.placeholder')}
                type="email"
                validate={{
                  required: { value: true, errorMessage: translate('register.messages.validate.email.required') },
                  maxLength: { value: 250, errorMessage: translate('global.messages.validate.email.maxlength') },
                  email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
                }}
                value={email ? email : ''}
                disabled={type === Rester_Type.EMAIL ? true : false}
              />

              <AvField
                name="mobile"
                label={translate('global.form.mobile.label')}
                placeholder={translate('global.form.mobile.placeholder')}
                validate={{
                  // required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                  number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
                  minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
                  maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') }
                }}
                value={mobile ? mobile : ''}
                disabled={type === Rester_Type.MOBILE ? true : false}
              />

              <label>{translate('global.form.code.label')}</label>
              <Row style={{ flex: 1 }}>
                <Col style={{ flex: 0.6 }}>
                  <AvField
                    name="captcha"
                    label=""
                    placeholder="Nhập mã xác thực"
                    type="text"
                    validate={{
                      required: { value: true, errorMessage: 'Nhập mã xác thực' }
                    }}
                  />
                </Col>

                <Col style={{ flex: 0.3 }}>
                  <img style={{ height: '39px' }} src={`data:image/jpeg;base64,${this.state.captcha}`} alt="" />
                </Col>

                <Col style={{ flex: 0.1 }}>
                  <img
                    // style={{ marginTop: '40px' }}
                    className=""
                    src={require('../../../../images/header/refresh.svg')}
                    onClick={this.invokeResetCaptcha}
                    alt=""
                  />
                </Col>
              </Row>

              <label className="lbl-term">
                <Translate contentKey="register.term1" />
                <a target="_blank">
                  <Translate contentKey="register.term2" />
                </a>
                <Translate contentKey="register.term3" />
              </label>

              <Button
                className="btn-register"
                type="submit"
                disabled={this.state.disableButtonReg}
                style={{ width: '100%', margin: '0 auto' }}
                block
              >
                <Translate contentKey="register.form.button">Register</Translate>
              </Button>

              <div style={{ marginTop: '10px' }}>
                <RegisterBottom isInsurance={false} />
              </div>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resultReg: storeState.register.resultReg,
  currentLocale: storeState.locale.currentLocale,
  resultAdd: storeState.register.resultAdd,
  responseCap: storeState.passwordReset.responseCaptcha,
  config: storeState.applicationProfile.config
});

const mapDispatchToProps = {
  reset,
  generateCaptcha,
  handleRegister
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterCcvcInfo);
